module.exports = __webpack_public_path__ + "img/modi-schedule.b9dd2689.png";